import { createContext } from "react";
export const UserContext = createContext();
export const AllUserContext = createContext();
export const UserFriendContext = createContext();
export const DateContext = createContext();
export const BalanceContext = createContext();
export const ExpenseContext = createContext();
export const ListContext = createContext({ exp: {} });
